<ul class="customDropdownMenu">
  <li>
    <button id="bh-{{url}}-support" class="customDropdownMenu__item" mat-button (click)="navigateTo('contactar-con-soporte'); track($event)" tabindex="-1">
      <i class="icon icon_support"></i>Canales de Atención
    </button>
  </li>
  <li>
    <button id="bh-{{url}}-support-doc" class="customDropdownMenu__item" mat-button tabindex="-1" (click)="goToUrl('https://help.haulmer.com/hc/web-hosting'); track($event)">
      <i class="icon icon_doc"></i>Artículos de Ayuda
    </button>
  </li>
  <li>
    <button id="bh-{{url}}-support-status" class="customDropdownMenu__item" mat-button tabindex="-1" (click)="goToUrl('https://status.bluehosting.host/'); track($event)">
      <i class="icon icon_status_service"></i>Estado de Servicios
    </button>
  </li>
  <li>
    <button id="bh-{{url}}-support-reclamos" class="customDropdownMenu__item" mat-button tabindex="-1" (click)="goToUrl(URL.SUPPORT_SUGGESTIONS); track($event)">
      <i class="icon icon_suggestions"></i>Reclamos o Felicitaciones
    </button>
  </li>
</ul>
